import AnalyticsRequester, { type ApiMetabaseEmbeddedRequest } from '@cobliteam/api-lib/src/dashboard/analytics';
import { Environment } from '@cobliteam/react-environments';
import { useQuery } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();

// Lazy instantiation to avoid circular dependency issues
const getAnalyticsRequester = () =>
  new AnalyticsRequester({
    host: env.apiHost,
  });

const QUERY_KEY = 'ANALYTICS';
const useAnalytics = () => {
  const getFromMetabaseEmbeddedDashboardApi = (dashboardId: number) =>
    useQuery<string>({
      queryKey: [QUERY_KEY, dashboardId],
      queryFn: () => getAnalyticsRequester().getFromMetabaseEmbeddedDashboardApi(dashboardId),
      staleTime: 1000 * 60 * 60 * 12, // 12 hour
      gcTime: 1000 * 60 * 60 * 12, // 12 hour
    });

  const getFromMetabaseQueryParams = (dashboardId: number, request: ApiMetabaseEmbeddedRequest) =>
    useQuery<string>({
      queryKey: [QUERY_KEY, dashboardId, request],
      queryFn: () => getAnalyticsRequester().getFromMetabaseQueryParams(request),
    });

  return {
    getFromMetabaseEmbeddedDashboardApi,
    getFromMetabaseQueryParams,
  };
};

export default useAnalytics;
